import React from "react";
import { useTranslation } from "react-i18next";
import { ReportState } from "../../../types/Rows";
import { getStateColor } from "../utils/calendarHelpers";
import { PLANNED_VISIT_STYLE } from "../../../utils/plannedVisitUtils";

interface StatusLegendProps {
  plannedReportsCount?: number;
}

export const StatusLegend: React.FC<StatusLegendProps> = ({ plannedReportsCount = 0 }) => {
  const { t } = useTranslation();

  const statusItems = [
    { state: ReportState.INPROGRESS, label: t("inProgress") },
    { state: ReportState.TO_VERIFY, label: t("toVerify") },
    { state: ReportState.TO_CORRECT, label: t("toCorrect") },
    { state: ReportState.ACCEPTED, label: t("accepted") },
  ];

  return (
    <div className="flex flex-wrap gap-4">
      {statusItems.map((item) => (
        <div key={item.state} className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{ backgroundColor: getStateColor(item.state) }}
          />
          <span className="text-sm">{item.label}</span>
        </div>
      ))}
      {/* Central Monitoring Indicator */}
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-4 rounded"
          style={{ backgroundColor: "#7C3AED" }}
        />
        <span className="text-sm">Monitoring centralny</span>
      </div>
      {/* Wizyty planowane: przyszła / odbyta z raportem / odbyta bez raportu */}
      <div className="flex flex-wrap items-center gap-4 ml-2 pl-4 border-l border-[var(--sc-border)]">
        <span className="text-sm text-[var(--sc-muted)]">{t("planned")} ({plannedReportsCount}):</span>
        {(["future", "done", "missing"] as const).map((s) => (
          <div key={s} className="flex items-center gap-2">
            <div
              className="w-4 h-4 rounded"
              style={{ backgroundColor: PLANNED_VISIT_STYLE[s].back, border: `2px solid ${PLANNED_VISIT_STYLE[s].border}` }}
            />
            <span className="text-sm">{PLANNED_VISIT_STYLE[s].label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
